export { default } from './LeadNotification';
